import React from 'react'
import { Link } from 'gatsby'

import './CategoriesNav.css'
import ALink from './ALink'

/**
 * Renders a sub navigation for a page.
 *
 * @param {boolean} hire Toggles hire link
 * @param {string} indexName Title of the Main Page
 * @param {string} indexSlug Slug of the Main Page
 * @param {boolean} [portfolio=true] Toggles portfolio link
 * @param {array} categories An array of categories
 */

const CategoriesNav = ({
  hire,
  indexName,
  indexSlug,
  categories = [],
  portfolio = true
}) => (
  <div className="CategoriesNav">
    <div className="CategoriesNav--Main">
      <Link
        className="NavLink"
        exact="true"
        activeClassName="activeLink"
        to={`/${indexSlug}/`}
      >
        {indexName}
      </Link>
    </div>
    <div className="CategoriesNav--Sub">
      {categories.map((category, index) => (
        <Link
          exact="true"
          className="NavLink"
          key={category.title + index}
          to={category.slug}
          activeClassName="activeLink"
        >
          {category.title}
        </Link>
      ))}
      {portfolio && (
        <Link
          exact="true"
          className="NavLink"
          to={`/our-work/category/${indexSlug}/`}
          activeClassName="activeLink"
        >
          Portfolio
        </Link>
      )}
      {hire && <ALink slug="/support/contact-us/" text="Hire Us" />}
    </div>
  </div>
)

export default CategoriesNav
